import { type AlertBanner, BannerType } from '../types';

export const BANNERS: Record<BannerType, AlertBanner> = {
    [BannerType.INVALID_INFORMATION]: {
        header: 'Invalid information',
        text: 'Please review the errors below',
        variant: 'error',
        icon: 'exclamation-circle-fill',
    },
    [BannerType.INVALID_SHIPPING_ADDRESS]: {
        header: 'Invalid shipping address',
        text: 'Please review the errors below',
        variant: 'error',
        icon: 'exclamation-circle-fill',
    },
    [BannerType.INVALID_PAYMENT_METHOD_ADYEN]: {
        header: 'Invalid payment method',
        text: 'Invalid card details, try again',
        variant: 'error',
        icon: 'exclamation-circle-fill',
    },
    [BannerType.INVALID_PAYMENT_METHOD_FORMIK]: {
        header: 'Invalid payment method',
        text: 'Please review the errors below',
        variant: 'error',
        icon: 'exclamation-circle-fill',
    },
    [BannerType.SUCCESS]: {
        header: 'Success',
        text: 'Your profile has been updated',
        variant: 'success',
        icon: 'check-circle-fill',
    },
    [BannerType.VERIFICATION_EMAIL_RESENT]: {
        header: 'Verification email resent',
        text: 'Please verify your account using the email we sent',
        variant: 'info',
    },
    [BannerType.VERIFY_YOUR_ACCOUNT]: {
        header: 'Please verify your account',
        text: 'using the email we’ve sent you. This allows you to use your points. ',
        variant: 'info',
    },
    [BannerType.OFFER_ACTIVATED]: {
        header: 'Offer activated!',
        variant: 'success',
        icon: 'check-circle-fill',
        dismissible: true,
        skipScrollToAlert: true,
    },
    [BannerType.UNABLE_TO_ACTIVATE_OFFER]: {
        header: 'Unable to activate',
        text: 'This offer might already be activated. Check your account for active offers',
        variant: 'error',
        icon: 'exclamation-circle-fill',
        dismissible: true,
        skipScrollToAlert: true,
    },
};
